<template>
  <div class="g-sidenav-show bg-gray-100 g-sidenav-hidden">
    <sidenav v-if="$store.state.showSidenav" :custom_class="$store.state.mcolor"
      :class="[$store.state.isTransparent, 'fixed-start',]" />
    <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
      <navbar v-if="$store.state.showNavbar" :class="[navClasses]"
        :text-white="$store.state.isAbsolute ? 'text-white opacity-8' : ''" :min-nav="navbarMinimize" />
      <router-view></router-view>
    </main>
  </div>
</template>
<script>
import Sidenav from "./Sidenav/index.vue";
import Navbar from "./Navbars/Navbar.vue";
import { mapMutations } from "vuex";
import axios from 'axios'
import api_provider from '../providers/api_provider';
// import jwt_decode from "jwt-decode";

// tokenSession

export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
  },
  computed: {
    isDemo() {
      return this.$store.state.isDemo === true;
    },
    navClasses() {
      return {
        "position-sticky blur shadow-blur mt-4 left-auto top-1 z-index-sticky":
          this.$store.state.isNavFixed,
        "position-absolute ps-4 pe-0 mx-0 w-100 z-index-2": /* px-4 */
          this.$store.state.isAbsolute,
        "ps-4 pe-0": !this.$store.state.isAbsolute,
      };
    },
  },
  beforeCreate: function () {
    // BFF opaco: la sesión se restaura desde el perfil persistido; el access token vive
    // en cookie HttpOnly y su renovación la gestiona el BFF (sin checkTokens en cliente).
    this.$store.commit('initializeStore')
    this.$store.commit('initCompanyId')
  },
  watch: {
    // Modo demo: una sola clase en el body enciende el ocultamiento en toda la app,
    // incluido lo que se renderiza fuera del arbol de Vue (popups de Leaflet, modales).
    isDemo: {
      immediate: true,
      handler(active) {
        document.body.classList.toggle('demo-mode', active === true);
      },
    },
  },
  mounted() {
    document.title = 'Mi GPS';
    // setInterval(() => {
    //   console.log('r', this.$store.state.refresh)
    //   console.log('a', this.$store.state.access)
    // }, 20000)
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-white";
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
  },
};
</script>

<style scoped>
@media (min-width: 1200px) {
  .g-sidenav-hidden .navbar-vertical.fixed-start~.main-content {
    margin-left: 6rem;
  }

  .g-sidenav-hidden .navbar-vertical:hover.fixed-start~.main-content {
    margin-left: 15.6rem;
  }
}
</style>